<template>
  <!-- New customer conversion funnel -->
  <div class="new-user-conversion-container">
    <!-- Query form area -->
    <div class="search-form">
      <a-form layout="inline">
        <a-form-item :label="$t('repayReport.datadt')">
          <a-range-picker v-model="dateRange" :format="'DD-MM-YYYY'" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- Export button -->
    <div class="export-btn-wrapper">
      <!-- <a-button type="primary" @click="handleExport">{{ $t('exportFile') }}</a-button> -->
    </div>

    <!-- Data table -->
    <a-table
      :columns="columns"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      :row-key="(record, index) => `${record.statDate}_${index}`"
      :scroll="{ x: 'max-content' }"
      class="conversion-table"
      @change="handleTableChange"
    >
      <!-- Date column formatting -->
      <template slot="statDate" slot-scope="text, record">
        <span v-if="record.statDate === 'Subtotal'" class="summary-row">{{ text }}</span>
        <span v-else>{{ text ? transformTime(text, 1) : '' }}</span>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getNewfunnel, exportNewfunnel } from '@/webpublicapi/vietnamBackstage'
export default {
  name: 'CustConvertListNew',
  components: {},
  data() {
    return {
      dateRange: [],
      loading: false,
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '15', '20'],
        showTotal: (total) => `${this.$t('display')} ${total}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('repayReport.datadt'),
          dataIndex: 'statDate',
          key: 'statDate',
          scopedSlots: { customRender: 'statDate' },
          width: 140,
          align: 'center',
        },
        {
          title: this.$t('repayReport.installs'),
          dataIndex: 'install',
          key: 'install',
          align: 'center',
        },
        {
          title: this.$t('repayReport.regCount'),
          dataIndex: 'regist',
          key: 'regist',
          align: 'center',
        },
        {
          title: this.$t('repayReport.logIn'),
          dataIndex: 'login',
          key: 'login',
          align: 'center',
        },
        {
          title: this.$t('repayReport.completeOpenAccountNum'),
          dataIndex: 'openAccount',
          key: 'openAccount',
          align: 'center',
        },
        {
          title: this.$t('repayReport.completeRiskAssessmentNum'),
          dataIndex: 'evaluation',
          key: 'evaluation',
          align: 'center',
        },
        {
          title: this.$t('repayReport.rechargeNum'),
          dataIndex: 'recharge',
          key: 'recharge',
          align: 'center',
        },
        {
          title: this.$t('repayReport.bidParticipantNum'),
          dataIndex: 'investNum',
          key: 'investNum',
          align: 'center',
        },
        {
          title: this.$t('repayReport.bidSuccessNum'),
          dataIndex: 'investSucessNum',
          key: 'investSucessNum',
          align: 'center',
        },
      ]
    },
  },
  created() {},
  mounted() {
    // Set default time to recent 7 days
    this.setDefaultDateRange()
    // Auto execute one query
    this.handleSearch()
  },
  methods: {
    // Set default date range to recent 7 days
    setDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(end.getDate() - 6) // Including today, total 7 days

      // Use moment.js to format date (Ant Design Vue DatePicker needs moment object)
      const moment = require('moment')
      this.dateRange = [moment(start), moment(end)]
    },

    // Query
    async handleSearch() {
      if (!this.dateRange || this.dateRange.length !== 2) return

      this.loading = true
      const startDate = this.dateRange[0].format('YYYY-MM-DD')
      const endDate = this.dateRange[1].format('YYYY-MM-DD')

      try {
        const result = await getNewfunnel({
          startDate,
          endDate,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
        })
        this.tableData = result.respData.records || []
        this.pagination.total = result.respData.total || 0
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    // Export
    async handleExport() {
      if (!this.dateRange || this.dateRange.length !== 2) return

      const startDate = this.dateRange[0].format('YYYY-MM-DD')
      const endDate = this.dateRange[1].format('YYYY-MM-DD')

      try {
        const result = await exportNewfunnel({
          startDate,
          endDate,
          pageNo: 1,
          pageSize: 10,
        })

        const blob = new Blob([result], { type: 'application/vnd.ms-excel' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${startDate}_${endDate}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error(error)
      }
    },

    // Table pagination change
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.handleSearch()
    },
  },
}
</script>

<style scoped>
.new-user-conversion-container {
  padding: 20px;
  background: #fff;
}

.search-form {
  margin-bottom: 16px;
}

.export-btn-wrapper {
  margin-bottom: 16px;
}

.conversion-table {
  margin-top: 16px;
}

.summary-row {
  font-weight: bold;
}
</style>
